import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';

import { useAccountsService } from '@restworld/data-services';

import { useEmployerUserContactsListQueryKey } from './use-employer-user-contacts-list-query';

function useDeleteEmployerUserContact() {
  const queryClient = useQueryClient();
  const queryKey = useEmployerUserContactsListQueryKey();
  const accountsService = useAccountsService();

  const mutation = useMutation({
    mutationFn: (userId: string) => accountsService.deleteEmployerUserContact({ userId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return mutation;
}
export default useDeleteEmployerUserContact;
